<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Create Account</v-toolbar-title>
          </v-toolbar>
          
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
              <v-text-field
                v-model="username"
                :rules="usernameRules"
                label="Username"
                prepend-icon="mdi-account"
                required
                @keyup.enter="submit"
              ></v-text-field>
              
              <v-text-field
                v-model="password"
                :rules="passwordRules"
                label="Password"
                prepend-icon="mdi-lock"
                :type="showPassword ? 'text' : 'password'"
                :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append-inner="showPassword = !showPassword"
                required
                @keyup.enter="submit"
              ></v-text-field>
              
              <v-text-field
                v-model="confirmPassword"
                :rules="confirmPasswordRules"
                label="Confirm Password"
                prepend-icon="mdi-lock-check"
                :type="showConfirmPassword ? 'text' : 'password'"
                :append-inner-icon="showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append-inner="showConfirmPassword = !showConfirmPassword"
                required
                @keyup.enter="submit"
              ></v-text-field>
            </v-form>
          </v-card-text>
          
          <v-card-actions>
            <v-btn
              text
              color="primary"
              @click="$router.push('/login')"
            >
              Back to Login
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!valid || loading"
              :loading="loading"
              @click="submit"
            >
              Create Account
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    
    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000">
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'

export default {
  name: 'Register',
  setup() {
    const router = useRouter()
    const authStore = useAuthStore()
    
    const valid = ref(false)
    const loading = ref(false)
    const username = ref('')
    const password = ref('')
    const confirmPassword = ref('')
    const showPassword = ref(false)
    const showConfirmPassword = ref(false)
    const snackbar = ref(false)
    const snackbarText = ref('')
    const snackbarColor = ref('error')
    
    const usernameRules = [
      v => !!v || 'Username is required',
      v => v.length >= 3 || 'Username must be at least 3 characters'
    ]
    
    const passwordRules = [
      v => !!v || 'Password is required',
      v => v.length >= 6 || 'Password must be at least 6 characters'
    ]
    
    const confirmPasswordRules = [
      v => !!v || 'Password confirmation is required',
      v => v === password.value || 'Passwords must match'
    ]
    
    const showMessage = (message, color = 'error') => {
      snackbarText.value = message
      snackbarColor.value = color
      snackbar.value = true
    }
    
    const submit = async () => {
      if (!valid.value) return
      
      loading.value = true
      
      try {
        const result = await authStore.register({
          username: username.value,
          password: password.value
        })
        
        if (result.success) {
          showMessage('Account created successfully! Please log in.', 'success')
          setTimeout(() => {
            router.push('/login')
          }, 2000)
        } else {
          showMessage(result.error)
        }
      } catch (error) {
        showMessage('An error occurred. Please try again.')
      } finally {
        loading.value = false
      }
    }
    
    return {
      valid,
      loading,
      username,
      password,
      confirmPassword,
      showPassword,
      showConfirmPassword,
      usernameRules,
      passwordRules,
      confirmPasswordRules,
      snackbar,
      snackbarText,
      snackbarColor,
      submit
    }
  }
}
</script>